import React from "react";
import styles from "./Footer.module.css";

function Footer() {
  return (
    <footer className={styles.footer}>
      API Portal · Emarsys · {new Date().getFullYear()}
    </footer>
  );
}

export default Footer;
